<section role="dialog" class="max-w-[80vw]" aria-modal="true" aria-labelledby="payment-address-title">
  @if(isLoader) {
    <div class="fixed inset-0 bg-opacity-50 backdrop-blur-sm flex items-center justify-center" style="z-index: 999;" role="status" aria-live="polite" aria-label="Loading">
      <mat-progress-spinner class="!h-[50px] !w-[50px]" mode="indeterminate" />
    </div>
  }
  @if(userInfoPop) {
    <div class="p-[1.25rem]" id="userInfoPop">
      <div class="content">
        <h2 mat-dialog-title id="payment-address-title" class="!min-h-fit my-2 !p-[30px_25px]">{{'USER_INFO_HEADER_1' | translate}}</h2>
        <mat-dialog-content class="!max-h-none !m-0 !p-0 flex flex-col !pl-[30px]">
          <p class="my-[5px] !font-bold">{{ profileInfo.deliveryFirstName }} {{ profileInfo.deliveryLastName }}</p>
          <p class="my-[5px]">{{ profileInfo.deliveryCompanyName }}</p>
          <p class="my-[5px]">{{ profileInfo.deliveryAddress }}</p>
          <p class="my-[5px]">{{ profileInfo.deliveryCity }}</p>
          <p class="my-[5px]">{{ deliveryCountryName }} - {{ profileInfo.deliveryPostalCode }}</p>
          <p class="my-[5px]">{{ profileInfo.deliveryMobileNumber }}</p>
        </mat-dialog-content>
      </div>
      <mat-dialog-actions role="group" aria-label="Address confirmation actions" class="">
        <button mat-flat-button class="" (click)="confirmPay()" type="button">{{'CONTINUE_BUTTON' | translate}}</button>
        <button mat-flat-button class="!bg-[var(--dsr-color-primary)]" (click)="openEditForm()" type="button" aria-label="Modify address">
          {{'MODIFY_BUTTON' | translate}}
        </button>
        <button mat-stroked-button class="" (click)="cancelPay()" type="button" aria-label="Cancel payment">{{'CANCEL_BUTTON' | translate}}</button>
      </mat-dialog-actions>
    </div>
  }
  @if(!userInfoPop) {
    <div>
      <form #editProfile="ngForm" class="flex flex-col gap-[3rem] p-[1.25rem]" (ngSubmit)="submitEditProfile()">
        <fieldset>
          <legend class="sr-only">Delivery address form</legend>
          <div class=" flex flex-col gap-[0.8rem]">
            <h2 mat-dialog-title id="payment-address-title" class="!min-h-fit">{{'HEADER_LIST_EDIT_PROFILE' | translate}}</h2>
          </div>
          <mat-dialog-content class="">
            <div class="!max-h-none !m-0 !p-0 flex flex-col gap-[2rem] pl-[25px] pr-[25px]">
              <span class="dsr-typescale-label-large-prominent !uppercase text-light-dsr-color-primary">
                {{'DELIVERY_ADDRESS_LABEL' | translate}}
              </span>
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-[5.5rem]">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{'FORM_FIRSTNAME_LABEL' | translate}}</mat-label>
                  <input matInput type="text" [(ngModel)]="profileInfo.deliveryFirstName" maxlength="30" autocomplete="given-name"
                    name="deliveryFirstName" #deliveryFirstName="ngModel" id="deliveryFirstName" pattern="^[^0-9]+$"  aria-required="true"
                    minlength="1" [attr.aria-invalid]="deliveryFirstName.invalid && deliveryFirstName.touched" required />
                  @if(deliveryFirstName.errors && deliveryFirstName.touched) {
                    <mat-error>{{'REGISTRATION_VALID_FIRSTNAME_ERROR' | translate}}</mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{'FORM_LASTNAME_LABEL' | translate}}</mat-label>
                  <input matInput type="text" id="deliveryLastName" name="deliveryLastName" [(ngModel)]="profileInfo.deliveryLastName" 
                    #deliveryLastName="ngModel" maxlength="30" pattern="^[^0-9]+$" required minlength="1" aria-required="true"
                    [attr.aria-invalid]="deliveryLastName.invalid && deliveryLastName.touched" autocomplete="family-name" />
                  @if(deliveryLastName.errors && deliveryLastName.touched) {
                    <mat-error>{{'REGISTRATION_VALID_NAME_ERROR' | translate}}</mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{'FORM_COMPANY_NAME_LABEL' | translate}}</mat-label>
                  <input matInput type="text" id="deliveryCompanyName" name="deliveryCompanyName" required
                    minlength="1" [(ngModel)]="profileInfo.deliveryCompanyName" #deliveryCompanyName="ngModel"
                    placeholder="{{'FORM_COMPANY_NAME_PLACEHOLDER' | translate}}" maxlength="30" disabled />
                  @if(deliveryCompanyName.errors && deliveryCompanyName.touched) {
                    <mat-error>{{'REGISTRATION_LABEL_COMPANY_ERROR' | translate}}</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-[5.5rem]">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{'FORM_COUNTRY_LABEL' | translate}}</mat-label>
                  <mat-select name="deliveryCountryId" [(ngModel)]="deliveryCountryId" id="deliveryCountryId"
                    (selectionChange)="countryChange($event.value)">
                    @for (country of data.filteredCountryList; track country) {
                      <mat-option [value]="country.countryId">{{country.countryName}}</mat-option>
                    }
                  </mat-select>
                  <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black"
                    class="pointer-events-none" aria-hidden="true"></dsr-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{'FORM_CITY_LABEL' | translate}}</mat-label>
                  <input matInput type="text" id="deliveryCity" name="deliveryCity" [(ngModel)]="profileInfo.deliveryCity" 
                    maxlength="30" required minlength="1" #deliveryCity="ngModel" aria-required="true"
                    [attr.aria-invalid]="deliveryCity.invalid && deliveryCity.touched" autocomplete="address-level2" />
                  @if(deliveryCity.errors && deliveryCity.touched) {
                    <mat-error>{{'REGISTRATION_LABEL_CITY_ERROR' | translate}}</mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{'FORM_POSTAL_CODE_LABEL' | translate}}</mat-label>
                  <input matInput type="text" id="deliveryPostalCode" name="deliveryPostalCode" required
                    #deliveryPostalCode="ngModel" [(ngModel)]="profileInfo.deliveryPostalCode"
                    [maxlength]="deliveryCountryId === 73 ? 5 : 9" autocomplete="postal-code"
                    [pattern]="deliveryCountryId === 73 ? '^\\d{5}$' : ''" aria-required="true"
                    [attr.aria-invalid]="deliveryPostalCode.invalid && deliveryPostalCode.touched" />
                  @if(deliveryPostalCode.errors && deliveryPostalCode.touched) {
                    <mat-error>{{'REGISTRATION_LABEL_CODE_ERROR' | translate}}</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-[5.5rem]">
                <div class="sm:col-span-2">
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>{{'FORM_ADDRESS_LABEL' | translate}}</mat-label>
                    <input matInput [(ngModel)]="profileInfo.deliveryAddress" name="deliveryAddress"
                      #deliveryAddress="ngModel" required placeholder="{{'FORM_ADDRESS_PLACEHOLDER' | translate}}"
                      id="deliveryAddress" type="text" aria-required="true" autocomplete="street-address"
                      [attr.aria-invalid]="deliveryAddress.invalid && deliveryAddress.touched" />
                    @if(deliveryAddress.errors && deliveryAddress.touched) {
                      <mat-error>{{'EDITPROFILE_ADDRESS_ERROR' | translate}}</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-[minmax(0,1.5fr)_minmax(0,3.5fr)] gap-[2.5rem] w-full sm:col-span-1">
                  <div class="min-w-0">
                    <mat-form-field appearance="outline" floatLabel="always" class="w-full">
                      <mat-label>{{'FORM_DIALLING_CODE_LABEL' | translate}}</mat-label>
                      <input matInput type="text" class="dialCode" [(ngModel)]="profileInfo.deliveryDiallingCode"
                        name="deliveryDiallingCode" readonly disabled />
                    </mat-form-field>
                  </div>
                  <div class="min-w-0">
                    <mat-form-field appearance="outline" class="w-full">
                      <mat-label>{{'FORM_PHONE_LABEL' | translate}}</mat-label>
                      <input matInput type="text" class="mobileNumber" id="deliveryMobileNumber"
                        name="deliveryMobileNumber" [(ngModel)]="profileInfo.deliveryMobileNumber"
                        placeholder="{{'FORM_PHONE_PLACEHOLDER' | translate}}" required
                        autocomplete="tel" (ngModelChange)="profileInfo.deliveryMobileNumber=$event"
                        pattern="^\d{4,13}$" aria-required="true"  #deliveryMobileNumber="ngModel"
                        [attr.aria-invalid]="deliveryMobileNumber.invalid && deliveryMobileNumber.touched" />
                      @if(deliveryMobileNumber.errors && deliveryMobileNumber.touched) {
                        <mat-error>{{'REGISTRATION_LABEL_MOBILE_ERROR' | translate}}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </mat-dialog-content>
          <mat-dialog-actions role="group" aria-label="Address form actions" class="">
            <button [disabled]="editProfile.invalid || !editProfile.dirty || !isFormChanged()"
              mat-flat-button class="" type="submit" [attr.aria-busy]="isLoader">
              <span class="">{{'CONFIRM_BUTTON' | translate}}</span>
            </button>
            <button mat-stroked-button color="primary" class="" type="button"
              (click)="backToHome()" aria-label="Cancel and return">
              <span class="">{{'CANCEL_BUTTON' | translate}}</span>
            </button>
          </mat-dialog-actions>
        </fieldset>
      </form>
    </div>
  }
</section>